<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12">
                    <h1 class="text-center text-heavy pad-top--xl pad-bottom--xl z-up text-white marg-bottom--none">
                        Order Process
                    </h1>
                </div>
            </div>
        </div>
        <img width="100%" src="../../../static/images/step1.png" alt="" />
        <img width="100%" src="../../../static/images/step2.png" alt="" />
        <img width="100%" src="../../../static/images/step3.png" alt="" />
        <img width="100%" src="../../../static/images/step4.png" alt="" />
        <div class="grid-container">
            <div class="grid-x grid-padding-x pad-top pad-bottom">
                <div class="cell small-12 medium-4">
                    <div class="card pad fix-height">
                        <p class="text-center">
                            <img width="112" src="../../../static/images/order-process/visual-proof.png" alt="" />
                        </p>
                        <h5 class="text-blue text-center">Visual proof</h5>
                        <p class="text-center small">
                            Once your order has been placed you will receive an Order Confirmation within 10 minutes and a Visual Proof within 24 hours.<br />
                            We create a visual representation in PDF format for every order that we receive. This will define the exact dimensions, the colours to be used and the position of your branding.<br />
                            We will only proceed into Production once this approval stage is signed off.
                        </p>
                    </div>
                </div>
                <div class="cell small-12 medium-4">
                    <div class="card pad fix-height">
                        <p class="text-center">
                            <img width="112" src="../../../static/images/order-process/box.png" alt="" />
                        </p>
                        <h5 class="text-blue text-center">Production</h5>
                        <p class="text-center small">
                            All of our Production is carried out in-house and we utilise the latest machinery, high tech systems, skilled operatives and have thorough Quality Control checks at every stage of the Production process to ensure that your order is of the highest quality.
                        </p>
                    </div>
                </div>
                <div class="cell small-12 medium-4">
                    <div class="card pad fix-height">
                        <p class="text-center">
                            <img width="112" src="../../../static/images/order-process/dispatch.png" alt="" />
                        </p>
                        <h5 class="text-blue text-center">Dispatch</h5>
                        <p class="text-center small">
                            Prior to dispatching your order, we conduct a final quality check and prepare your order for delivery. As soon as your order has been dispatched we will send you live tracking information.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'HowToOrder',
    metaInfo() {
        return {
            title: 'How to order',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'How to order from Customised Clothing' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/how-to-order' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/HowToOrder.vue